import React from 'react';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PlusLightIcon(props) {
  return <FontAwesomeIcon icon={faPlus} {...props} />;
}
